import React, { useState } from 'react';
import { suggestEmail } from '../utils/emailSuggestion';
import '../styles/EmailSuggestion.scss';

// Tracks when to offer a correction for an email field: only after the visitor
// leaves the field (not mid-typing), and only until they change the address again.
export function useEmailSuggestion(email) {
  const [checked, setChecked] = useState(null);
  const suggestion = checked !== null && checked === email ? suggestEmail(email) : null;
  return { suggestion, onBlur: () => setChecked(email) };
}

// "Did you mean ada@gmail.com?" under an email field. Tapping the address fills it
// in; ignoring it is fine too — the form submits whatever was typed.
function EmailSuggestion({ suggestion, onAccept }) {
  if (!suggestion) return null;
  return (
    <p className="email-suggestion" role="status">
      Did you mean{' '}
      <button type="button" onClick={() => onAccept(suggestion)}>{suggestion}</button>?
    </p>
  );
}

export default EmailSuggestion;
